import React from 'react';

const SkeletonLoader = ({ className }: { className?: string }) => (
  <div className={`bg-gray-800/50 animate-pulse rounded-lg ${className}`} />
);

export const NavigationSkeleton = () => (
  <div className="fixed top-0 left-0 right-0 z-50 h-20 bg-gray-900/80 backdrop-blur-sm">
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
      <SkeletonLoader className="w-24 h-8" />
      <div className="hidden md:flex items-center space-x-8">
        <SkeletonLoader className="w-16 h-6" />
        <SkeletonLoader className="w-16 h-6" />
        <SkeletonLoader className="w-16 h-6" />
        <SkeletonLoader className="w-16 h-6" />
      </div>
      <div className="md:hidden">
        <SkeletonLoader className="w-8 h-8" />
      </div>
    </div>
  </div>
);

export const HeroSkeleton = () => (
  <div className="relative w-full h-screen overflow-hidden">
    <SkeletonLoader className="w-full h-full" />
    <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
      <SkeletonLoader className="w-3/4 h-16 md:h-24 mb-6" />
      <SkeletonLoader className="w-1/2 h-8 md:h-10" />
    </div>
  </div>
);

export const SectionSkeleton = ({ hasImage = true }: { hasImage?: boolean }) => (
  <div className="py-24 md:py-32">
    <div className="container mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
        {hasImage && <SkeletonLoader className="w-full h-80 rounded-2xl" />}
        <div className="flex flex-col">
          <SkeletonLoader className="w-3/4 h-12 mb-4" />
          <SkeletonLoader className="w-full h-6 mb-2" />
          <SkeletonLoader className="w-full h-6 mb-2" />
          <SkeletonLoader className="w-5/6 h-6" />
        </div>
      </div>
    </div>
  </div>
);

export const FooterSkeleton = () => (
  <footer className="bg-gray-900/80 border-t border-gray-800">
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex justify-between items-center">
      <SkeletonLoader className="w-1/3 h-6" />
      <div className="flex items-center space-x-6">
        <SkeletonLoader className="w-8 h-8 rounded-full" />
        <SkeletonLoader className="w-8 h-8 rounded-full" />
      </div>
    </div>
  </footer>
);
